<template>
  <span v-if="allowed" class="pos-send-action">
    <v-btn small outlined :disabled="disabled" @click="open"><v-icon left small>mdi-tablet-dashboard</v-icon>An Kasse senden</v-btn>
    <pos-dialog v-model="dialog" title="An Kasse senden" :busy="busy" :width="520">
      <p class="pos-dialog__intro">{{ label }}</p>
      <v-progress-linear v-if="loading" indeterminate color="primary" />
      <v-alert v-if="error" type="error" text dense>{{ error }}</v-alert>
      <div v-if="result" class="pos-delivery-status" role="status"><v-icon :color="result.status === 'opened' ? 'success' : 'primary'">{{ result.status === 'opened' ? 'mdi-check-circle-outline' : 'mdi-inbox-arrow-down-outline' }}</v-icon><strong>{{ statusLabel }}</strong></div>
      <v-radio-group v-else v-model="terminalId" hide-details class="pos-terminal-choices">
        <v-radio v-for="terminal in terminals" :key="terminal.id" :value="terminal.id" :disabled="!terminal.online" :label="terminal.name + (terminal.online ? '' : ' (offline)')" />
      </v-radio-group>
      <div v-if="!loading && !terminals.length && !result" class="pos-empty"><v-icon size="32">mdi-tablet-off</v-icon><strong>Keine Kasse eingerichtet</strong></div>
      <template #actions><v-btn text :disabled="busy" @click="dialog = false">Schliessen</v-btn><v-spacer /><v-btn v-if="!result" color="primary" depressed :loading="busy" :disabled="!terminalId || loading" @click="send"><v-icon left>mdi-send-outline</v-icon>Senden</v-btn><v-btn v-else outlined :loading="loading" @click="refreshStatus"><v-icon left>mdi-refresh</v-icon>Status prüfen</v-btn></template>
    </pos-dialog>
  </span>
</template>
<script>
import userService from "@/services/userService"
import api, { errorMessage, operationId } from "@/api/posApi"
import PosDialog from "./PosDialog.vue"
export default {
  components: { PosDialog },
  props: { source: { type: Object, required: true }, studioId: { type: String, required: true }, label: String, disabled: Boolean },
  data: () => ({ dialog: false, busy: false, loading: false, error: "", terminals: [], terminalId: "", result: null, pending: null, sequence: 0, poll: null }),
  computed: {
    allowed() { return userService.hasRight("cassa_admin") },
    statusLabel() { return { pending: "An die Kasse gesendet. Wartet auf Öffnung.", opened: "Auf der Kasse geöffnet", declined: "An der Kasse abgelehnt", expired: "Übergabe abgelaufen" }[this.result && this.result.status] || "" },
  },
  watch: { dialog(value) { if (!value) { this.sequence++; window.clearTimeout(this.poll) } } },
  beforeDestroy() { this.sequence++; window.clearTimeout(this.poll) },
  methods: {
    async open() {
      if (this.result && ["opened", "declined", "expired"].includes(this.result.status)) { this.pending = null; this.result = null }
      this.dialog = true; this.error = ""; this.terminalId = this.pending ? this.pending.body.terminalId : ""; this.loading = true
      const sequence = ++this.sequence
      try { const result = await api.terminals(this.studioId); if (sequence === this.sequence) this.terminals = result.items }
      catch (error) { if (sequence === this.sequence) this.error = errorMessage(error) }
      finally { if (sequence === this.sequence) { this.loading = false; if (this.result) this.refreshStatus() } }
    },
    async send() {
      if (this.busy || !this.terminalId) return
      const payload = { ...this.source, terminalId: this.terminalId }, key = JSON.stringify(payload)
      if (!this.pending || this.pending.key !== key) this.pending = { key, body: { ...payload, requestId: operationId() } }
      this.busy = true; this.error = ""
      try { this.result = await api.send(this.pending.body); if (this.dialog) this.poll = window.setTimeout(this.refreshStatus, 3000) }
      catch (error) { this.error = errorMessage(error) }
      finally { this.busy = false }
    },
    async refreshStatus() {
      window.clearTimeout(this.poll)
      if (!this.dialog || !this.result || this.loading) return
      this.loading = true
      const sequence = this.sequence
      try { const result = await api.handoff(this.result.id); if (sequence !== this.sequence) return; this.result = result; if (result.status === "pending") this.poll = window.setTimeout(this.refreshStatus, 5000) }
      catch (error) { if (sequence === this.sequence) this.error = errorMessage(error) }
      finally { if (sequence === this.sequence) this.loading = false }
    },
  },
}
</script>
